import { UserInformationBasic } from '@/api'

import { RadioTab, Space, ValidationMessage } from '../../../components/core-v2'
import { Mutation } from '../types'

export const RoleDfmAndCatSection = ({
  errors,
  isPortfolioManagerScreen,
  onMutate,
  user
}: {
  errors: { [key: string]: string }
  isPortfolioManagerScreen?: boolean
  onMutate: (mutation: Mutation<UserInformationBasic>) => void
  user: UserInformationBasic
}) => (
  <>
    {isPortfolioManagerScreen ? (
      <div className="block">
        <label htmlFor="edit-user__role">Role</label>
        <div className="role">
          <select disabled id="edit-user__role" value="PortfolioManager">
            <option value="PortfolioManager">Portfolio Manager</option>
          </select>
        </div>
      </div>
    ) : (
      <div>
        <Space mb={3}>
          <label className="radio-group" htmlFor="edit-pm">
            Additionally assign as a Portfolio Manager?
          </label>
        </Space>
        <Space isflex id="edit-pm">
          <Space mr={5}>
            <RadioTab
              data-testid="pm-1-option"
              isSelected={!user.roles.includes('PortfolioManager')}
              onClick={() =>
                onMutate(u => {
                  u.roles = u.roles.filter(role => role !== 'PortfolioManager')
                  u.portfolioManagerCategory = undefined
                })
              }
            >
              No
            </RadioTab>
          </Space>
          <Space>
            <RadioTab
              data-testid="pm-2-option"
              isSelected={!!user.roles.includes('PortfolioManager')}
              onClick={() =>
                onMutate(u => {
                  if (!u.roles.includes('PortfolioManager')) {
                    u.roles.push('PortfolioManager')
                  }
                  u.portfolioManagerCategory = 'Cat1'
                })
              }
            >
              Yes
            </RadioTab>
          </Space>
        </Space>
      </div>
    )}
    {(user.roles.includes('PortfolioManager') || isPortfolioManagerScreen) && (
      <div>
        <Space mb={3}>
          <label className="radio-group" htmlFor="edit-user__cat">
            Category
          </label>
        </Space>
        <Space isflex id="edit-user__cat">
          <Space mr={5}>
            <RadioTab
              data-testid="cat-1-option"
              isSelected={user.portfolioManagerCategory === 'Cat1'}
              onClick={() => onMutate(u => (u.portfolioManagerCategory = 'Cat1'))}
            >
              CAT 1
            </RadioTab>
          </Space>
          <Space>
            <RadioTab
              data-testid="cat-2-option"
              isSelected={user.portfolioManagerCategory === 'Cat2'}
              onClick={() => onMutate(u => (u.portfolioManagerCategory = 'Cat2'))}
            >
              CAT 2
            </RadioTab>
          </Space>
        </Space>
        <ValidationMessage errors={errors} fieldName="portfolioManagerCategory" />
      </div>
    )}
  </>
)
